
import AuditKendaraanTradoEditorMain from "../../features/audit-kendaraan/audit-kendaraan-trado/audit-kendaraan-trado-editor/component/AuditKendaraanTradoEditorMain";

const AuditKendaraanTradoEditorPage = () => {
  return <AuditKendaraanTradoEditorMain />;
};

export default AuditKendaraanTradoEditorPage;
